module.exports = __webpack_public_path__ + "static/img/head-logo.cf4f68b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head-logo.png
// module id = BG3T
// module chunks = 1